<template>
    <b-row align-self="end" align-h="end">
        <b-col cols="12">
            <h6>* saldo retido de vendas a cartão de crédito no período anterior</h6>
            <h6>** vendas a crédito ocorridas no período deste relatório serão pagas no repasse de mesmo período do mês seguinte</h6>
            <h6 v-if="obs != ''">*** {{ obs }}</h6>
        </b-col>
    </b-row>
</template>

<script>
export default {
    component: "FooterRelatorio",
    props: {
        obs:{
            default: "",
            type: String
        }
    },
    data: () => {
        return {
        }
    },
}
</script>